import React from 'react';
import Cookies from 'js-cookie';
import useWindowSize from '../../hooks/useWindowSize';

function splitText(input) {
  const text = input.replace(/<\/?[^>]+(>|$)/g, '');
  const [numberPart, ...restParts] = text.split(/(?<=\+)\s/);
  return [numberPart.trim(), restParts.join(' ').trim()];
}
function OurMerits({ data }) {
  const { width } = useWindowSize();
  const lang = Cookies.get('i18next') || 'en';
  return (
    <div className="our__merits">
      <div className="our__merits-bg_circle" />
      {width > 768 && <div className="our__merits-bg_circle center" />}
      <div className="container medium">
        <div className="our__merits-content">
          <h2 className="our__merits-title">
            {data.title[lang]}
          </h2>
          <div className="our__merits-list">
            <div className="our__merits-item">
              <p className="our__merits-item-number">{splitText(data.branches[lang])[0]}</p>
              <p className="our__merits-item-text">{splitText(data.branches[lang])[1]}</p>
            </div>
            {width > 768 && <div className="our__merits-item-line" />}
            <div className="our__merits-item">
              <p className="our__merits-item-number">{splitText(data.served_customers[lang])[0]}</p>
              <p className="our__merits-item-text">{splitText(data.served_customers[lang])[1]}</p>
            </div>
            {width > 768 && <div className="our__merits-item-line" />}
            <div className="our__merits-item">
              <p className="our__merits-item-number">{splitText(data.types_analyses[lang])[0]}</p>
              <p className="our__merits-item-text">{splitText(data.types_analyses[lang])[1]}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurMerits;
